type Props = { className?: string; animated?: boolean; title?: string };

export function FixhenLogo({ className, animated = false, title = "FIXHEN" }: Props) {
  // Staged reveal (0 → 1.5s): dark anchor snaps in first, then the royal arm,
  // then the sky-pop cap, and finally the outline draws itself.
  const aDark = animated ? "animate-logo-dark" : "";
  const aRoyal = animated ? "animate-logo-royal" : "";
  const aSky = animated ? "animate-logo-sky" : "";
  const aStroke = animated ? "animate-logo-stroke" : "";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 215 250"
      className={className}
      role="img"
      aria-label={title}
      style={{ contain: "layout paint" }}
    >
      <title>{title}</title>
      {/* Layer 1 — dark anchor (the F spine + lower arm). Enters first. */}
      <polygon
        points="40,140 90,105 145,105 145,160 90,160 90,230 40,230"
        fill="#172554"
        className={aDark}
        style={{ transformOrigin: "92px 167px" }}
      />
      {/* Layer 2 — royal arm (top-right block sweeping down). */}
      <polygon
        points="110,20 175,20 175,70 90,70 90,105 40,140 40,69"
        fill="#2563EB"
        className={aRoyal}
        style={{ transformOrigin: "107px 80px" }}
      />
      {/* Layer 3 — sky cap (the small triangle at the very top). */}
      <polygon
        points="40,20 110,20 40,69"
        fill="#7DD3FC"
        className={aSky}
        style={{ transformOrigin: "75px 45px" }}
      />
      {/* Layer 4 — outline drawn in. pathLength=1 lets one dasharray value cover every stroke. */}
      <g className={aStroke}>
        <line x1="110" y1="20" x2="40" y2="69" stroke="#000" strokeWidth={2} pathLength={1} />
        <line x1="90" y1="105" x2="40" y2="140" stroke="#000" strokeWidth={2} pathLength={1} />
        <path
          d="M 40,20 L 175,20 L 175,70 L 90,70 L 90,105 L 145,105 L 145,160 L 90,160 L 90,230 L 40,230 Z"
          fill="none"
          stroke="#000"
          strokeWidth={4}
          strokeLinejoin="miter"
          pathLength={1}
        />
      </g>
    </svg>
  );
}